<div class="form-horizontal">

    <div class="form-group" [formGroup]="experimentDesignFormGroup">
        <label class="col-sm-4 control-label">Create new draft Seed Request?
            <a tooltip="Setting to 'Yes' will create a draft SREQ seed request upon submission"
                placement="top"
                container="body">
                <span class="glyphicon glyphicon-info-sign"></span>
            </a>
        </label>
        <span class="col-sm-8">
            <ui-switch formControlName="seedRequestDesired" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
        </span> 
    </div>

    <div class="form-group">
        <label class="col-sm-4 control-label">
            Existing Seed Requests
        </label>
    
        <div class="col-sm-4 form-control-static" *ngIf="!anySeedRequests">
            None
        </div>

        <div class="col-sm-4" *ngIf="anySeedRequests">
            <table class="table">
                <thead>
                    <tr>
                    <th>Seed Request Batch ID</th>
                    <th>Batch Creation Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let batch of seedRequests">
                        <td>{{ batch.batchId }}</td>
                        <td>{{ batch.batchCreationDate | date: 'MM/dd/yyyy' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/seed-requests/seed-requests.component.html